import React from 'react';

const EntityTable = ({
  items = [],
  columns = [],
  schema = {},
  listType = '',
  getOptionLabel = (k, v) => v,
  onEdit,
  onDelete,
  canEdit = true,
  canDelete = true,
  allMemberTypeNames,
  emptyMessage = 'Inga bokningar gjorda.'
}) => {
  if (!items || items.length === 0) {
    return <li style={{ listStyle: 'none', textAlign: 'center' }}>{emptyMessage}</li>;
  }

  return (
    <>
      <li className={`grid items-list_header ${listType}`}>
        {columns.map((key, index) => {
          const fieldLabel = schema[key]?.label || schema[key]?.[0] || key;
          return (
            <div className="flex flex-column item-list-all_item" key={index}>
              <strong>{fieldLabel}</strong>
            </div>
          );
        })}
      </li>
      {items.map((item, itemIndex) => (
        <li className={`grid items-list_row fade-in ${listType}`} key={item.id || itemIndex}>
          {columns.map((key, index) => (
            <div className="flex flex-column item-list-all_item" key={index}>
              {getOptionLabel ? getOptionLabel(key, item[key], allMemberTypeNames) : item[key]}
            </div>
          ))}

          {canEdit && onEdit && (
            <button className="item-list-all_button" onClick={() => onEdit(item)}>
              Edit
            </button>
          )}
          {canDelete && onDelete && (
            <button className="item-list-all_button" onClick={() => onDelete(item.id !== undefined ? item.id : itemIndex, item)}>
              Delete
            </button>
          )}
        </li>
      ))}
    </>
  );
};

export default EntityTable;
export { EntityTable };
